import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { PaywallProvider } from "@/context/PaywallContext";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { ReviewBanner } from "@/components/ReviewBanner";
import { PullToRefresh } from "@/components/PullToRefresh";
import { PremiumTour } from "@/components/PremiumTour";
import Welcome from "@/pages/Welcome";
import Auth from "@/pages/Auth";
import AuthCallback from "@/pages/AuthCallback";
import Generator from "@/pages/Generator";
import Bible from "@/pages/Bible";
import Feed from "@/pages/Feed";
import WhatsNew from "@/pages/WhatsNew";
import Plans from "@/pages/Plans";
import PlanDetail from "@/pages/PlanDetail";
import PrayerRequest from "@/pages/PrayerRequest";
import History from "@/pages/History";
import DailyDecree from "@/pages/DailyDecree";
import Teachings from "@/pages/Teachings";
import Community from "@/pages/Community";
import PublicProfile from "@/pages/PublicProfile";
import Lexicon from "@/pages/Lexicon";
import Profile from "@/pages/Profile";
import Feedback from "@/pages/Feedback";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Admin from "@/pages/Admin";
import Premium from "@/pages/Premium";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="text-center pt-32 font-decree text-xl text-[#7A756E]">Loading…</div>;
  if (!user) return <Navigate to="/auth" replace />;
  return children;
}

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <div className="App min-h-screen flex flex-col">
      <PullToRefresh />
      <Header />
      <ReviewBanner />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Welcome />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/generate" element={<Generator />} />
          <Route path="/bible" element={<Bible />} />
          <Route path="/prayer" element={<PrayerRequest />} />
          <Route path="/feed" element={<Protected><Feed /></Protected>} />
          <Route path="/whats-new" element={<WhatsNew />} />
          <Route path="/daily" element={<Protected><DailyDecree /></Protected>} />
          <Route path="/plans" element={<Protected><Plans /></Protected>} />
          <Route path="/plans/:id" element={<Protected><PlanDetail /></Protected>} />
          <Route path="/teachings" element={<Protected><Teachings /></Protected>} />
          <Route path="/lexicon" element={<Protected><Lexicon /></Protected>} />
          <Route path="/community" element={<Protected><Community /></Protected>} />
          <Route path="/u/:id" element={<Protected><PublicProfile /></Protected>} />
          <Route path="/profile" element={<Protected><Profile /></Protected>} />
          <Route path="/history" element={<Protected><History /></Protected>} />
          <Route path="/feedback" element={<Feedback />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/premium" element={<Premium />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Footer />
      <PremiumTour />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <PaywallProvider>
          <AppRoutes />
          <Toaster position="bottom-center" toastOptions={{ style: { fontFamily: "DM Sans, sans-serif" } }} />
        </PaywallProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
